import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components'
import { Box } from '@mui/material';

const ServerTabScreen = () => {
  const navigate = useNavigate();
  return (
    <Box mt={-2}>
      <CustomTab
      base={'/admin/servidor'}
        panels={[
          {
            name: "Servidor",
            route: '/admin/servidor/estado',
            onChange: () => navigate('estado'),
            content: <Outlet />
          },
          {
            name: "Configuración",
            route: '/admin/servidor/configuracion',
            onChange: () => navigate('configuracion'),
            content: <Outlet />
          },
          {
            name: "Monitor de Servicios",
            route: '/admin/servidor/monitor',
            onChange: () => navigate('monitor'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default ServerTabScreen